import $ from "jquery";

import('jquery').then(async ($) => {
	$('.without-caption').magnificPopup({
		type:'image',
		closeOnContentClick:true,
		closeBtnInside:true,
		mainClass:'mfp-no-margins mfp-with-zoom',
		image: {
		verticalFit:true
		},
			zoom: {
			enabled:true,
			duration:300
		},
			gallery: {
			enabled:true
		},
	});
});

var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
  return new bootstrap.Tooltip(tooltipTriggerEl)
  
})



$(function () {
	$('.notification_teaser').each(function(){
		var note_id = $(this).attr('id');
		if ($(window).width() < 1200){
			$(this).closest('.notification_teaser').css('padding-top', $('header.top').outerHeight() + 25);
		}

		$(this).find('.close').on('click', function () {
			$(this).closest('.notification_teaser').removeClass('in').animate({ 'margin-top': -1 * $(this).closest('.notification_teaser').outerHeight(), opacity: 0 }, 1000, function(){$(this).closest('.notification_teaser').hide()});
		localStorage.setItem(note_id, 'off');
	});

		$(this).css('margin-top', -1 * $(this).outerHeight());
		if (!localStorage.getItem(note_id)) {
		$(this).delay(2000).addClass('in').animate({ 'margin-top': 0, opacity: 1 }, 1000);
	}
	else {
		$(this).hide();
	}
		jQuery(document).on('keypress', function (e) {
		if (e.keyCode == 42) { localStorage.removeItem(note_id); console.log('LocalStorage cleared.') }
	});
	});
});